import { JsonName } from 'tserialize';

export class CouponModel {
  /** Код купона */
  @JsonName() code!: string | null;

  /** Скидка по купону */
  @JsonName('discount_price_value') discountPriceValue: number = 0;
}
